import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { account, billing } from "../../api/endpoints";

export default function Billing() {
  const { t } = useTranslation();
  const [packages, setPackages] = useState([]);
  const [balance, setBalance] = useState(null);
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    billing.packages().then((r) => setPackages(r.data));
    account.tokens().then((r) => setBalance(r.data));
  }, []);

  async function buy(pkg) {
    setBusy(pkg.id);
    setError(null);
    try {
      const { data } = await billing.initiate(pkg.id);
      if (data?.payment_url) {
        window.location.href = data.payment_url;
      } else {
        setError(t("billing.missingPaymentUrl"));
      }
    } catch (err) {
      setError(err?.response?.data?.detail || t("billing.providerError"));
    } finally {
      setBusy(null);
    }
  }

  return (
    <div className="space-y-8 max-w-4xl">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">{t("billing.title")}</h1>
        <p className="text-sm text-slate-600">{t("billing.subtitle")}</p>
      </div>

      {balance && (
        <div className="card flex items-center justify-between">
          <div>
            <div className="text-xs text-slate-500 uppercase tracking-wide">
              {t("billing.currentBalance")}
            </div>
            <div className="mono text-3xl font-bold text-brand-800">
              {balance.token_balance}
            </div>
            <div className="text-xs text-slate-500">
              {t("billing.tokensScansRemaining", {
                count: balance.estimated_scans_remaining,
              })}
            </div>
          </div>
        </div>
      )}

      {error && (
        <div className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700 ring-1 ring-red-200">
          {error}
        </div>
      )}

      <div className="grid sm:grid-cols-3 gap-4">
        {packages.length === 0 ? (
          <div className="card text-slate-500 col-span-3">
            {t("billing.noPackages")}
          </div>
        ) : (
          packages.map((p) => (
            <div key={p.id} className="card flex flex-col gap-3">
              <div>
                <div className="text-sm text-slate-500">{p.name}</div>
                <div className="mono text-2xl font-bold mt-1">{p.tokens}</div>
                <div className="text-xs text-slate-500">{t("billing.tokens")}</div>
              </div>
              <div className="mono text-lg text-slate-900">
                {Number(p.price_uah).toFixed(2)} UAH
              </div>
              <button
                className="btn-primary mt-auto"
                onClick={() => buy(p)}
                disabled={busy === p.id}
              >
                {busy === p.id ? t("billing.redirecting") : t("billing.buy")}
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
